import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../common/Modal';
import * as shapes from '../../shapes';

const ReassignButton = ({ barbers, reassign, on, off, isOn, selected, disabled }) => (
  <div
    className="u-inline-block"
  >
    <button
      type="button"
      className="c-btn c-btn--medium u-width-120 u-mr"
      onClick={on}
      disabled={!selected.id || selected.items || disabled}
    >
      Reassign
    </button>
    <Modal
      title="Choose a barber"
      close={off}
      showCloseButton
      display-if={isOn}
    >
      <div className="u-m+">
        {barbers.map(barber => (
          <button
            key={barber.id}
            type="button"
            className="c-btn c-btn--reassign u-1/1"
            onClick={reassign(barber)}
          >
            {barber.firstName} {barber.lastName}
          </button>
        ))}
      </div>
    </Modal>
  </div>
);
ReassignButton.propTypes = {
  barbers: shapes.barbers,
  on: shapes.handler.isRequired,
  off: shapes.handler.isRequired,
  isOn: shapes.flag.isRequired,
  selected: PropTypes.object.isRequired, // eslint-disable-line
  reassign: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
ReassignButton.defaultProps = {
  barbers: [],
};

export default ReassignButton;
